import '.a{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.b7{min-height:100vh;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.t{padding:2rem;}.ssr-plugin'
import '.g{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'
import { Head } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'

export const MaintenancePage = ({ message }: { message?: string }) => {
  const translations = useTranslations().app

  return (
    <div className="a m n b b7 ae t g"
    >
      <Head>
        <title>CrowdBuilding</title>
      </Head>
      <Image
        src={fullLogo}
        alt="CrowdBuilding"
        resizeHeight={48}
        style={{ height: '3rem' }}
      />
      <Text.Large
        style={{
          textAlign: 'center',
          maxWidth: '36rem',
        }}
      >
        {message || translations.landingPage.maintenanceMessage}
      </Text.Large>
    </div>
  )
}
